function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10a6.5 6.5 0 0 0-6.464 7.188l.736-.446a1 1 0 0 1 1.226.148l1.37 1.37a1 1 0 0 1 .24 1.026l-.85 2.53A6.5 6.5 0 1 0 15.5 10zm-4.565 11.127l.726-2.16-1.37-1.37-1.056.64a6.495 6.495 0 0 0 1.7 2.89zM8 16.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0zm5.665-2.947a1 1 0 0 1 .894-.553h3.79a1 1 0 0 1 .554.168l1.007.671a1 1 0 0 1 .34 1.28l-.728 1.456a.999.999 0 0 1-.447.447l-.681.34-.804 2.01a1 1 0 0 1-.928.628h-.535a1 1 0 0 1-.961-.725l-.853-2.984-.81-.648a1 1 0 0 1-.27-1.228l.432-.862zm4.684.447h-3.79l-.431.862.81.648a1 1 0 0 1 .337.506L16.127 19h.535l.803-2.01a1 1 0 0 1 .481-.522l.681-.34.728-1.457L18.35 14z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.9a32f5aec0da22efe7b523331e88ad5a.svg";
export { ForwardRef as ReactComponent };